import options from './rules.component';

export default {
    selector: 'dtRulesList',
    options
};



// WEBPACK FOOTER //
// ./app/common/rules-list/index.js